// Copyright (c) 2016 Deere & Company

import actions from '../../../action-list';

export const updatePin = pin => ({
    pin,
    type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_PIN
});



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/pin.js